export const disableEventBubbling = <T extends EventTarget>(
  e: React.MouseEvent<T> | React.TouchEvent<T>
) => {
  e.preventDefault();
  e.stopPropagation();
};
